import React, { Component } from "react";
import { getInstitutes } from "../services/instituteService";
import firebase from "../services/firebaseconn";
import InstituteCard from "./instituteCard";
import { getUser } from "../services/userService";
import { getPageMessages } from "../services/pageMessageService";
import FootBar from "./footBar";

class Home extends Component {
  state = {
    institutes: [],
    currentUser: {},
    unsubscribeUser: undefined,
    homeMessage: "",
  };

  async componentDidMount() {
    const unsubscribeUser = firebase.auth().onAuthStateChanged(async (user) => {
      if (user && user.email) {
        try {
          const currentUser = await getUser(user.email);

          if (!currentUser) return (window.location = "/logout");

          const pageMessages = await getPageMessages();
          this.setState({ currentUser, homeMessage: pageMessages.homeMessage });
        } catch (err) {
          console.log(err);
          return (window.location = "/logout");
        }
      } else {
        return (window.location = "/login");
      }
    });

    const institutes = await getInstitutes();
    this.setState({ institutes, unsubscribeUser });
    // unsubscribe();
  }

  componentWillUnmount() {
    this.state.unsubscribeUser();
  }

  renderInstituteCards(searchValue) {
    const { institutes } = this.state;

    let matchedInstitutes;
    if (searchValue) {
      matchedInstitutes = institutes.filter((institute) => {
        return (
          institute.name.toLowerCase().includes(searchValue.toLowerCase()) ||
          institute.abbrev.toLowerCase().includes(searchValue.toLowerCase())
        );
      });
    } else {
      matchedInstitutes = institutes;
    }
    return matchedInstitutes.map((institute) => (
      <div key={institute.id}>{<InstituteCard institute={institute} />}</div>
    ));
  }

  render() {
    const { searchValue } = this.props;
    // const icon = Reaction.icon;
    return (
      <>
        <h5
          style={{ whiteSpace: "break-spaces" }}
          className="d-flex justify-content-center"
        >
          {this.state.homeMessage}
        </h5>

        <div>
          {this.renderInstituteCards(searchValue)}
        </div>

        <FootBar/>
      </>
    );
  }
}

export default Home;
